if (!customElements.get("main-product-v2")) {
  class mainProduct extends HTMLElement {
    constructor() {
      super();
      this.product = null;
      this.selectedVariant = null;

      this.currency = window.Shopify.currency.active || 'USD'
      this.language = window.Shopify.locale || 'en-US'
      this.moneyFormatter = new Intl.NumberFormat(this.language, {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    connectedCallback() {
      this.product = JSON.parse(this.querySelector(".main-product-json").innerHTML);
      this.mainSlider = this.querySelector('.main-product-v2__gallery');
      this.thumbnails = this.querySelector('.main-product-v2__thumbnails');
      this.optionInputs = this.querySelectorAll('.main-product-v2__input');
      this.sellingPlans = this.querySelectorAll('.main-product-v2__selling-plans');
      this.addToCartVarinatInput = this.querySelector('.main-product-v2__product-variant-id');
      this.addToCartButtons = this.querySelectorAll('.main-product-v2__atc-button');
      this.sellingPlanInputs = this.querySelectorAll('.main-product-v2__selling-plan-input');
      this.addToCartForm = this.querySelector('form[action="/cart/add"]');

      this.initSliders();
      this.initSelectedVariant();
      if (this.selectedVariant) {
        this.enforceUsOnlyVariantLimit();
        this.updateContainerVariantAttribute(this.selectedVariant.id);
        this.initSellingPlanForVariant(this.selectedVariant.id);
      } else {
        // If no variant selected, show all images
        this.updateImageVisibility(null);
      }

      this.syncUpdModalPanels();
      this.onChangeVariant();
      this.onChangeSellingPlans();
      this.handleAddToCartButtonClick();
      this.addToCartAndCheckout(this.addToCartForm);
    }

    onChangeSellingPlans() {
      this.sellingPlanInputs.forEach(input => {
        input.addEventListener('change', () => {
          const planId = input.value;

          this.setSellingPlanForATCFormInput(planId);
          this.updateSellingPlanParam(planId);

          this.toggleSubscriptionState(planId);
          this.updateATCButtonPrice(planId);
          
          // Update variant ID based on selling plan selection
          if (this.selectedVariant) {
            this.setVariantForATCFormInput(this.selectedVariant.id);
          }
        });
      });
    }

    setSellingPlanForATCFormInput(planId) {
      const input = this.querySelector('.main-product-v2__selling-plan-id');
      if (input) input.value = planId || "";
    }

    updateSellingPlanParam(planId) {
      const url = new URL(window.location);
      
      if (planId) {
        url.searchParams.set("selling_plan", planId);
      } else {
        url.searchParams.delete("selling_plan");
      }
      
      window.history.replaceState(null, "", url);
    }

    getSellingPlanFromUrl() {
      const url = new URL(window.location);
      return url.searchParams.get("selling_plan");
    }

    initSellingPlanForVariant(variantId) {
      if (!variantId) return;

      const wrapper = this.querySelector(`.main-product-v2__selling-plans[data-variant-id="${variantId}"]`);
      let planId = "";

      if (wrapper) {
        const checkedInput = wrapper.querySelector('.main-product-v2__selling-plan-input:checked') || 
                            wrapper.querySelector('.main-product-v2__selling-plan-input');
        planId = checkedInput ? checkedInput.value : "";
      }

      this.setSellingPlanForATCFormInput(planId);
      this.updateSellingPlanParam(planId);

      this.toggleSubscriptionState(planId);
      this.updateATCButtonPrice(planId);

      return planId;
    }

    onChangeVariant() {
      this.optionInputs.forEach(input => {
        input.addEventListener('change', () => {
        const selectedOptions = Array.from(this.optionInputs).filter(input => input.checked).map(input => input.value);    

          const matchingVariant = this.product.variants.find(variant => {
            return variant.options.every(opt => selectedOptions.includes(opt));
          });

          if (matchingVariant) {
            this.updateSelectedVariantById(matchingVariant.id);
            this.onShowCurrentSellingPlan(matchingVariant.id);
            this.setVariantForATCFormInput(matchingVariant.id);
            this.initSellingPlanForVariant(matchingVariant.id);
          }
          this.syncUpdModalPanels();
        });
      });
    }

    syncUpdModalPanels() {
      const panelRoot = this.querySelector('[data-main-product-modal-panels]');
      const firstUpdFieldset = this.querySelector('.main-product-v2__options fieldset.main-product-v2__option--upd');
      if (!firstUpdFieldset) return;

      const radios = firstUpdFieldset.querySelectorAll('.main-product-v2__input');
      const checkedRadio = firstUpdFieldset.querySelector('.main-product-v2__input:checked');

      if (!panelRoot) {
        this.syncUpdBadgePanels(checkedRadio);
        return;
      }

      const panels = panelRoot.querySelectorAll('[data-panel-index]');
      let index = 0;
      radios.forEach((radio, i) => {
        if (radio.checked) index = i;
      });
      const maxPanel = panels.length ? panels.length - 1 : 0;
      const safeIndex = Math.min(index, maxPanel);

      panels.forEach((panel) => {
        const pi = parseInt(panel.getAttribute('data-panel-index'), 10);
        panel.style.display = pi === safeIndex ? 'block' : 'none';
      });

      this.syncUpdBadgePanels(checkedRadio);
    }

    syncUpdBadgePanels(checkedRadioEl) {
      const badgeRoots = this.querySelectorAll('[data-main-product-badge-panels]');
      if (!badgeRoots.length) return;

      const selectedValue = checkedRadioEl ? String(checkedRadioEl.value || '') : '';

      badgeRoots.forEach((badgeRoot) => {
        const panels = Array.from(badgeRoot.querySelectorAll('[data-badge-panel]'));
        if (!panels.length) return;

        const activePanel =
          (selectedValue && panels.find((p) => String(p.dataset.matchValue || '') === selectedValue)) || panels[0];

        panels.forEach((p) => {
          p.style.display = p === activePanel ? 'inline' : 'none';
        });
      });
    }

    toggleSubscriptionState(planId) {
      const isSubscription = !!planId;

      const subscriptionTexts = this.querySelectorAll('.main-product-v2__subscription-text');
      const singleTexts = this.querySelectorAll('.main-product-v2__sing-product-text');

      if (isSubscription) {
        subscriptionTexts.forEach((el) => el.classList.remove('main-product-v2__subscription-text--hidden'));
        singleTexts.forEach((el) => el.classList.add('main-product-v2__sing-product-text--hidden'));
      } else {
        subscriptionTexts.forEach((el) => el.classList.add('main-product-v2__subscription-text--hidden'));
        singleTexts.forEach((el) => el.classList.remove('main-product-v2__sing-product-text--hidden'));
      }
    }

    initSliders() {
      if(this.thumbnails) {
        this.thumbsSwiper = new Swiper(this.thumbnails, {
          slidesPerView: 7,
          spaceBetween: 4,
          loop: true,
          breakpoints: {
            1023: {
              spaceBetween: 15,
            }
          }
        });
      }

      if (this.mainSlider) {
        const galleryRoot =
          this.mainSlider.closest('.main-product-v2__gallery-shell') || this.mainSlider.parentElement;
        const arrowsRow = galleryRoot?.querySelector('.main-product-v2__gallery-arrows');
        const paginationEl = arrowsRow?.querySelector('.main-product-v2__gallery-pagination');
        const prevEl = arrowsRow?.querySelector('.main-product-v2__gallery-arrow--prev');
        const nextEl = arrowsRow?.querySelector('.main-product-v2__gallery-arrow--next');

        this.mainSwiper = new Swiper(this.mainSlider, {
          slidesPerView: 1,
          loop: true,
          grabCursor: true,
          effect: 'fade',
          allowTouchMove: true,
          keyboard: {
            enabled: true,
            onlyInViewport: false,
            pageUpDown: false,
          },
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
          },
          navigation:
            prevEl && nextEl
              ? {
                  prevEl,
                  nextEl,
                }
              : undefined,
          pagination: paginationEl
            ? { el: paginationEl, clickable: true }
            : undefined,
          thumbs: {
            swiper: this.thumbsSwiper,
          },
        });

        const frontrowSticker = galleryRoot?.querySelector('.main-product-v2__frontrow-sticker');
        const syncFrontrowSticker = () => {
          if (!frontrowSticker || !this.mainSwiper) return;
          frontrowSticker.classList.toggle('is-hidden', this.mainSwiper.realIndex !== 0);
        };
        syncFrontrowSticker();
        this.mainSwiper.on('slideChange', syncFrontrowSticker);
      }
    }

    initSelectedVariant() {
      const optionCount = this.product.options_with_values?.length || 0;
      const checkedInputs = Array.from(this.optionInputs).filter((i) => i.checked);
      if (optionCount > 0 && checkedInputs.length === optionCount) {
        const selectedOptions = checkedInputs.map((i) => i.value);
        const fromDom = this.product.variants.find((variant) =>
          variant.options.every((opt) => selectedOptions.includes(opt))
        );
        if (fromDom) {
          this.selectedVariant = fromDom;
          return;
        }
      }

      const popularVariant = this.product.variants.find(
        (v) => v.available && v.metafields?.custom?.is_most_popular
      );
      const variantId =
        this.getVariantIdFromUrl() || popularVariant?.id || this.getFirstAvailableVariantId();
      const variant = this.getVariantById(variantId);

      if (variant) {
        this.selectedVariant = variant;
      }
    }

    getVariantIdFromUrl() {
      return new URL(document.location).searchParams.get("variant");
    }

    getFirstAvailableVariantId() {
      const firstAvailableVariant = this.product.variants.find(
        (variant) => variant.available
      );
      return firstAvailableVariant
        ? firstAvailableVariant.id
        : this.product.variants[0]?.id;
    }

    updateSelectedVariantById(variantId) {
      if (variantId) {
        this.updateVariantParam(variantId);
        this.selectedVariant = this.getVariantById(variantId);
        this.updateContainerVariantAttribute(variantId);
      }
    }

    updateContainerVariantAttribute(variantId) {
      const container = this.querySelector('.main-product-v2__container');
      if (container && variantId) {
        container.setAttribute('data-variant', variantId);
        this.enforceUsOnlyVariantLimit();
        this.updateImageVisibility(variantId);
        this.updateVariantSections(variantId);
      }
    }

    enforceUsOnlyVariantLimit() {
      if (!this.hasAttribute('data-limit-by-us-only')) return;
      const country = (this.getAttribute('data-country') || '').toUpperCase();
      if (country === 'US') return;
      const limitValue = (this.getAttribute('data-variant-limit-us') || '').trim();
      if (!limitValue) return;

      const checked = this.querySelector('.main-product-v2__input:checked');
      if (!(checked instanceof HTMLInputElement)) return;
      if (!checked.disabled) return;

      const fieldset = checked.closest('fieldset');
      if (!fieldset) return;
      const fallback = fieldset.querySelector('.main-product-v2__input:not([disabled])');
      if (!(fallback instanceof HTMLInputElement)) return;

      fallback.checked = true;
      fallback.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateVariantSections(variantId) {
      if (!this.hasAttribute('data-variants-section')) return;

      this.querySelectorAll('component-accordions').forEach((el) => {
        if (typeof el.closeAll === 'function') el.closeAll();
      });

      const variant = variantId != null && variantId !== ''
        ? this.getVariantById(variantId)
        : this.selectedVariant;
      if (!variant) return;

      const haystack = [variant.title, ...(variant.options || [])]
        .filter(Boolean)
        .join(' | ')
        .toLowerCase();

      const matches = (needle) =>
        !!needle && haystack.includes(needle.trim().toLowerCase());

      document.querySelectorAll('.js-variant-section').forEach((input) => {
        const needle = input.value || '';
        if (!needle.trim()) return;
        const section =
          input.closest('section') || input.closest('[id^="shopify-section-"]');
        if (!section) return;
        section.style.display = matches(needle) ? '' : 'none';
      });

      document.querySelectorAll('[data-vr-based]').forEach((el) => {
        const needle = el.getAttribute('data-vr-based') || '';
        if (!needle.trim()) return;
        el.style.display = matches(needle) ? '' : 'none';
      });
    }

    updateImageVisibility(variantId) {
      const useAltFilter = this.hasAttribute('data-upd-view');
      const variant =
        variantId != null && variantId !== ''
          ? this.getVariantById(variantId)
          : this.selectedVariant;

      const passesAltFilter = (img, baseVisible) => {
        if (!useAltFilter || !img.hasAttribute('data-upd-filter-idx')) return baseVisible;
        if (!variant) return false;
        const idx = parseInt(img.getAttribute('data-upd-filter-idx'), 10);
        if (Number.isNaN(idx) || idx < 0 || idx >= variant.options.length) return false;
        const altTrim = (img.getAttribute('alt') || '').trim();
        return baseVisible && variant.options[idx] === altTrim;
      };

      const variantIdsMatch = (img) => {
        if (!variantId) return true;
        const raw = img.getAttribute('data-variant');
        if (!raw) return true;
        return raw.split(',').map((v) => v.trim()).includes(String(variantId));
      };

      const setImgVisible = (img, show) => {
        img.style.display = show ? 'block' : 'none';
        const picture = img.closest('picture');
        if (picture) picture.style.display = show ? 'block' : 'none';
      };

      const setSlideVisible = (slide, show) => {
        slide.style.opacity = show ? '' : '0';
        slide.style.pointerEvents = show ? '' : 'none';
      };

      // Updated view grouped slides:
      // - Slide-level `data-alt-group` (when present): hide entire slide if its
      //   alt value doesn't match any of the selected variant's option values.
      // - `passesAltFilter` decides WHICH "type" (sleep type) image should be
      //   visible within a slide.
      // - Inside one consolidated variant slide, prefer the image whose
      //   `data-variant` matches the selected variantId; fall back to a generic
      //   (no data-variant) image so the slide isn't empty.
      const updateGroupedSlideVisibility = (slideSelector) => {
        const slides = this.querySelectorAll(slideSelector);
        slides.forEach((slide) => {
          const altGroup = (slide.getAttribute('data-alt-group') || '').trim();
          const slideAltMatches = !useAltFilter || !altGroup || !variant
            ? true
            : variant.options.some((opt) => (opt || '').trim() === altGroup);

          setSlideVisible(slide, slideAltMatches);

          const imgs = Array.from(slide.querySelectorAll('img:not(.main-product-v2__sticker)'));
          if (!imgs.length) return;

          imgs.forEach((img) => setImgVisible(img, false));
          if (!slideAltMatches) return;

          const candidates = imgs.filter((img) => passesAltFilter(img, true));
          if (!candidates.length) return;

          const variantSpecific = candidates.filter(
            (img) => img.hasAttribute('data-variant') && variantIdsMatch(img),
          );
          const generic = candidates.filter((img) => !img.hasAttribute('data-variant'));
          const chosen = variantSpecific[0] || generic[0] || candidates[0] || null;
          if (chosen) setImgVisible(chosen, true);
        });
      };

      // 1) Handle grouped slides first (pick ONE image per slide)
      updateGroupedSlideVisibility('[data-upd-alt-slide-group].main-product-v2__gallery-slide');
      updateGroupedSlideVisibility('[data-upd-alt-slide-group].main-product-v2__thumbnails-slide');

      this.querySelectorAll(
        '.main-product-v2__gallery-slide img:not(.main-product-v2__sticker)'
      ).forEach((img) => {
        if (img.closest && img.closest('[data-upd-alt-slide-group]')) return;
        const base = variantIdsMatch(img);
        const show = passesAltFilter(img, base);
        setImgVisible(img, show);
      });

      this.querySelectorAll(
        '.main-product-v2__thumbnails-slide img:not(.main-product-v2__sticker)'
      ).forEach((img) => {
        if (img.closest && img.closest('[data-upd-alt-slide-group]')) return;
        const base = variantIdsMatch(img);
        img.style.display = passesAltFilter(img, base) ? 'block' : 'none';
      });
    }

    getVariantById(variantId) {
      return (
        this.product.variants.find((variant) => variant.id === +variantId) ||
        this.product.variants.find((variant) => variant.available) ||
        this.product.variants[0]
      );
    }

    updateVariantParam(variantId) {
      const newUrl = new URL(document.location);
      newUrl.searchParams.set("variant", variantId);
      window.history.replaceState(null, "", newUrl);
    }

    setVariantForATCFormInput(varinatId) {
      // Check if "Buy it Once" is selected (no selling plan)
      const sellingPlanInput = this.querySelector('.main-product-v2__selling-plan-id');
      const planId = sellingPlanInput?.value || '';
      
      // Only use onetime variant if "Buy it Once" is selected (planId is empty)
      if (!planId) {
        const fieldset = this.querySelector(`.main-product-v2__selling-plans[data-variant-id="${varinatId}"]`);
        const onetimeVariantId = fieldset?.getAttribute('data-otp-variant-id');
        
        // Use onetime variant ID if available, otherwise use the regular variant ID
        this.addToCartVarinatInput.value = onetimeVariantId || varinatId;
      } else {
        // Use regular variant ID when subscription is selected
        this.addToCartVarinatInput.value = varinatId;
      }
    }

    updateATCButtonPrice(planId) {
      const variant = this.selectedVariant;
      if (!variant) return;

      let price = variant.price;

      if (planId && variant.selling_plans) {
        const plan = variant.selling_plans.find(sp => sp.id == planId);
        if (plan && plan.price != null) {
          price = plan.price; 
        }
      }

      const priceEls = this.querySelectorAll('.main-product-v2__atc-button-price');
      priceEls.forEach((el) => {
        el.textContent = this.money(price);
      });
    }

    onShowCurrentSellingPlan(variantId) {
      this.sellingPlans.forEach(sellingPlanWrapper => {
        const sellingPlanWrapperId = +sellingPlanWrapper.getAttribute('data-variant-id');
        
        if(sellingPlanWrapperId == variantId) {
          sellingPlanWrapper.classList.remove('main-product-v2__selling-plans--hidden');
        } else {
          sellingPlanWrapper.classList.add('main-product-v2__selling-plans--hidden');
        }
      });
    }

    handleAddToCartButtonClick() {
      if (!this.addToCartForm || !this.addToCartButtons.length) return;

      this.addToCartForm.addEventListener('click', (e) => {
        const clickedButton = e.target.closest('.main-product-v2__atc-button');
        if (!clickedButton) return;

        this._isRedirecting = false;

        const form = this.addToCartForm;
        const formData = new FormData(form);
        const mainVariantSellingPlan = formData.get("selling_plan") ? +formData.get("selling_plan") : null;

        var useAlternativeSubLink = false;

        if (window.useAltCheckoutLink) {
          useAlternativeSubLink = true;
        }
        
        
        let checkoutLink = null;
        if (mainVariantSellingPlan) {
          checkoutLink = useAlternativeSubLink
            ? this.selectedVariant?.metafields?.custom?.checkout_sub_link_alternative
            : this.selectedVariant?.metafields?.custom?.checkout_link;
        } else {
          checkoutLink = this.selectedVariant?.metafields?.custom?.checkout_otp_link;
        }

        if (checkoutLink) {
          checkoutLink = this.removeCartClearFromCheckoutLink(checkoutLink);

          e.preventDefault();
          e.stopPropagation();
          
          this._isRedirecting = true;
          
          window.location.replace(checkoutLink);
        }
      });
    }

    async addToCartAndCheckout(form) {
      form.addEventListener('submit', async (e) => {
        if (this._isRedirecting) {
          e.preventDefault();
          return;
        }

        e.preventDefault();

        this.addToCartButtons.forEach((btn) => { btn.disabled = true; });

        try {
          const data = new FormData(form);
          const mainVariantSellingPlan = data.get("selling_plan") ? +data.get("selling_plan") : null;

          const mainVariantId = +data.get("id");

          const itemsToAdd = [{
            id: mainVariantId,
            quantity: 1,
            ...(mainVariantSellingPlan ? { selling_plan: mainVariantSellingPlan } : {})
          }];

          (window.UPSELL_PRODUCTS || []).forEach(upsellId => {
            itemsToAdd.push({
              id: +upsellId,
              quantity: 1
            });
          });

          if (mainVariantSellingPlan && window.UPSELL_FOR_SUBSCRIPTION && window.UPSELL_FOR_SUBSCRIPTION[mainVariantId]) {
            window.UPSELL_FOR_SUBSCRIPTION[mainVariantId].forEach(subsId => {
              itemsToAdd.push({
                id: +subsId,
                quantity: 1
              });
            });
          }

          await this.addItemsToCart(itemsToAdd);

          // window.location.href = '/checkout';

        } catch (err) {
          console.error("PDP add error:", err);
        } finally {
          this.addToCartButtons.forEach((btn) => { btn.disabled = false; });
        }
      });
    }

    async addItemsToCart(items) {
      if (!items.length) return;

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.description || res.statusText);
      }

      return await res.json();
    }

    removeCartClearFromCheckoutLink(url) {
      if (!url || typeof url !== 'string') return url;
      try {
        const parsed = new URL(url);
        if (parsed.pathname !== '/cart/clear') return url;
        const returnTo = parsed.searchParams.get('return_to');
        if (!returnTo) return url;
        const decoded = decodeURIComponent(returnTo);
        if (!decoded.startsWith('/')) return url;
        return parsed.origin + decoded;
      } catch {
        return url;
      }
    }

    money(price) {
      const formatted = this.moneyFormatter.format(price / 100.0);
      // Remove "A" prefix from AUD currency (A$ -> $)
      return formatted.replace(/^A\$/, '$');
    }
  }

  customElements.define("main-product-v2", mainProduct);
}